import { setAppBackgroundColor } from '../AppContainer';
import { OrderSummaryContainerWrapper, OrderSummaryModalWrapper } from './styles';

type OrderSummaryContainerProps = {
  children: React.ReactNode;
  backgroundColor?: string;
};

export const OrderSummaryContainer = ({
  backgroundColor,
  children,
}: OrderSummaryContainerProps) => {
  setAppBackgroundColor(backgroundColor ?? 'transparent');

  return (
    <OrderSummaryModalWrapper>
      <OrderSummaryContainerWrapper>{children}</OrderSummaryContainerWrapper>
    </OrderSummaryModalWrapper>
  );
};
